<template>
  <div>
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <section class="hero">
      <div class="hero-content">
        <img src="../assets/icon.jpg" alt="Gogo Saporu" class="bot-icon" />
        <h1>Términos y Condiciones</h1>
        <p>Gogo Saporu - Última actualización: 4 de agosto de 2025</p>
      </div>
    </section>

    <div class="page-container">
      <h2>1. Aceptación de los Términos</h2>
      <p>Al acceder y utilizar Gogo Saporu, aceptas cumplir con estos términos y condiciones. Si no estás de acuerdo con alguno de estos términos, no utilices nuestro servicio.</p>

      <h2>2. Descripción del Servicio</h2>
      <p>Gogo Saporu es una plataforma gratuita que permite a los usuarios:</p>
      <ul>
        <li>Registrarse y crear una cuenta personal</li>
        <li>Iniciar sesión en la plataforma</li>
        <li>Subir y compartir posts que pueden contener texto e imágenes</li>
        <li>Interactuar con el contenido de otros usuarios</li>
      </ul>
      <p><strong>Importante:</strong> Gogo Saporu no ofrece servicios de venta ni transacciones comerciales.</p>

      <h2>3. Registro y Cuentas de Usuario</h2>
      <p>Para utilizar ciertas funciones del servicio, debes crear una cuenta proporcionando información veraz y completa. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña.</p>
      <p>No hay restricciones de edad para el uso de la plataforma, pero los menores deben contar con la supervisión de sus padres o tutores.</p>

      <h2>4. Contenido del Usuario</h2>
      <p>Los usuarios pueden subir posts que contengan texto e imágenes. Al subir contenido, garantizas que:</p>
      <ul>
        <li>Tienes los derechos necesarios sobre el contenido</li>
        <li>El contenido cumple con las leyes de la Unión Europea</li>
        <li>El contenido no infringe derechos de terceros</li>
      </ul>
      <p>Puedes eliminar tu contenido y tu cuenta en cualquier momento a través de la configuración de tu perfil.</p>

      <h2>5. Moderación y Contenido Prohibido</h2>
      <p>Gogo Saporu no realiza moderación activa del contenido, pero nos reservamos el derecho de eliminar contenido que:</p>
      <ul>
        <li>Viole las leyes de España o la Unión Europea</li>
        <li>Sea claramente ilegal o perjudicial</li>
        <li>Contenga spam o actividad maliciosa</li>
      </ul>

      <h2>6. Cookies y Datos</h2>
      <p>Actualmente, Gogo Saporu recopila información mínima necesaria para el funcionamiento del servicio. En el futuro, podríamos implementar:</p>
      <ul>
        <li>Cookies para mejorar la experiencia de inicio de sesión</li>
        <li>Anuncios de Google para financiar el servicio</li>
      </ul>
      <p>Te notificaremos de cualquier cambio en nuestra política de privacidad.</p>

      <h2>7. Limitaciones del Servicio</h2>
      <p>Gogo Saporu se proporciona "tal como está". No garantizamos la disponibilidad continua del servicio ni nos hacemos responsables de:</p>
      <ul>
        <li>Pérdida de datos o contenido</li>
        <li>Interrupciones del servicio</li>
        <li>Errores o fallos técnicos</li>
      </ul>

      <h2>8. Modificaciones</h2>
      <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios significativos serán notificados a los usuarios registrados.</p>

      <h2>9. Jurisdicción</h2>
      <p>Estos términos se rigen por las leyes de España. Cualquier disputa será resuelta en los tribunales competentes de España.</p>

      <h2>10. Contacto</h2>
      <p>Si tienes preguntas sobre estos términos y condiciones, puedes contactarnos a través de nuestra página de desarrolladores.</p>

      <div class="terms-footer">
        <p><em>Al continuar usando Gogo Saporu, confirmas que has leído y aceptado estos términos y condiciones.</em></p>
      </div>
    </div>
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
    <AdSense />
  </div>
</template>

<script>
import AdSense from './AdSense.vue';
export default {
  name: "AppTermsOfService",
  components: {
    AdSense
  }
};
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 4rem 0;
  text-align: center;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.bot-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 2rem;
}

h1 {
  color: white;
  font-size: 3rem;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

h2 {
  color: white;
  font-size: 1.8rem;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 0.5rem;
}

p {
  color: white;
  line-height: 1.6;
  margin-bottom: 1rem;
}

ul {
  color: white;
  line-height: 1.6;
  margin-bottom: 1rem;
}

li {
  margin-bottom: 0.5rem;
}

.page-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 3rem 2rem;
}

.terms-footer {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 2rem;
  margin-top: 3rem;
  text-align: center;
}

.terms-footer p {
  margin: 0;
  font-style: italic;
  font-size: 1.1rem;
}

strong {
  color: #ffd700;
}
</style>
